<div class="m-2">
  <button class="btn btn-circle operator-button mt-2 me-2">
    {{ operation }}
  </button>
</div>
